import { client } from '@/client';

// 导出
export function exportAll() {
  return client.post('/api/ops_envinfo/env/export', {});
}

// 导出集群
export function exportCluster(params) {
  return client.post('/api/ops_clusters/cluster/export', params);
}

// 上传JSON脚本
export function uploadFile(params) {
  return client.form('/api/ops_envinfo/env/import', params);
}

// 上传集群
export function importCluster(params) {
  return client.form('/api/ops_clusters/cluster/import', params);
}

// 集群列表
export function clusterList(params) {
  return client.post('/api/ops_clusters/page-query', params);
}

// 删除集群
export function deleteCluster(id) {
  return client.delete(`/api/ops_clusters/delete/${id}`);
}

// 获取集群详情
export function getClusterDetail(id) {
  return client.get(`/api/ops_clusters/detail/${id}`);
}

// 制品上传
export function libUpload(params) {
  return client.form('/api/ops_envinfo/product_lib/upload', params);
}

// 环境列表
export function getEnvList() {
  return client.get('/api/ops_envinfo/env/list');
}

export function getK8sList(params) {
  return client.post('/api/ops_k8s_cluster/page-query', params);
}

// 编辑cluster
export function editCluster(params) {
  return client.put('/api/ops_clusters/update', params);
}

// 新增cluster
export function createCluster(params) {
  return client.post('/api/ops_clusters/create', params);
}

// 获取集群信息
export function getClusterInfo(id) {
  return client.get(`/api/ops_clusters/info/${id}`);
}

// 代理列表
export function getProxyList() {
  return client.get('/api/ops_envinfo/proxy/list');
}

// 代理列表
export function getLibList() {
  return client.get('/api/ops_envinfo/product_lib/list');
}

// 删除环境
export function deleteEnv(params) {
  return client.delete('/api/ops_envinfo/env/delete', params);
}

// 删除代理
export function deleteProxy(params) {
  return client.delete('/api/ops_envinfo/proxy/delete', params);
}

// 删除制品库
export function deleteLib(params) {
  return client.delete('/api/ops_envinfo/product_lib/delete', params);
}

// 创建环境
export function createEnv(params) {
  return client.post('/api/ops_envinfo/env/create', params);
}

// 创建环境
export function createProxy(params) {
  return client.post('/api/ops_envinfo/proxy/create', params);
}

// 创建制品
export function createLib(params) {
  return client.post('/api/ops_envinfo/product_lib/create', params);
}

// 更新环境
export function updateEnv(params) {
  return client.put('/api/ops_envinfo/env/update', params);
}

// 更新环境
export function updateProxy(params) {
  return client.put('/api/ops_envinfo/proxy/update', params);
}

// 更新制品
export function updateLib(params) {
  return client.put('/api/ops_envinfo/product_lib/update', params);
}

// 获取proxy 下拉数据
export function getProxyOptions() {
  return client.get('/api/ops_envinfo/proxy/options');
}

// 获取制品库 下拉数据
export function getLibOptions() {
  return client.get('/api/ops_envinfo/product_lib/options');
}

// 获取制品库数据
export function getComponentLibList(params) {
  return client.post('/api/exec_component_service/version/list', params);
}

// 自动更新版本
export function updateAuto(params) {
  return client.post('/api/exec_component_service/version/updateAuto', params);
}

// 自动更新全部版本
export function updateAutoAll(params) {
  return client.post('/api/exec_component_service/version/updateAutoAll', params);
}

// 删除制品库数据
export function deleteComponentLib(id) {
  return client.delete(`/api/exec_component_service/version/del/${id}`);
}

// 获取列表详情
export function getClusterList(params) {
  return client.post('/api/ops_clusters/clusters-query', params);
}

// 获取主机列表
export function getHostList(params) {
  return client.post('/api/ops_hosts/hosts-query', params);
}

// 获取筛选数据
export function getQuickFilterList(params) {
  return client.get('/api/ops_clusters/cluster-components', params);
}

// 创建主机
export function createHost(params) {
  return client.post('/api/ops_hosts/create_with_credential', params);
}

// 输入密码确认
export function confirmPwd(params) {
  return client.post('/api/ops_hosts/create_with_password', params);
}

// 删除Host
export function deleteHost(id, params) {
  return client.delete(`/api/ops_hosts/delete/${id}`, params);
}

// 验证
export function validateHost(params) {
  return client.post('/api/ops_hosts/validate', params);
}

// 主机详情
export function getHostDetail(id) {
  return client.get(`/api/ops_hosts/detail/${id}`);
}

// 下载Excel 1.密码 2.秘钥
export function downloadHostExcel(type) {
  return client.post(
    `/api/ops_hosts/template/download/${type}`,
    { responseType: 'arrayBuffer' },
    { isBlob: true },
  );
}

// 导入秘钥
export function uploadHostPrvKey(params) {
  return client.form(`/api/ops_hosts/uploadPrvKey`, params);
}

// 导入Excel
export function importHostExcel(params, formParams) {
  return client.form(`/api/ops_hosts/upload/${params.clusterId}/${params.type}`, formParams);
}

// 验证k8s
export function validateK8s(id) {
  return client.post(`/api/ops_k8s_cluster/validateK8s/${id}`);
}

// 删除k8s
export function deleteK8s(id) {
  return client.delete(`/api/ops_k8s_cluster/delete/${id}`);
}

// k8s服务筛选
export function getServiceList() {
  return client.get('/api/exec_component_service/env');
}

// 上传配置
export function k8sUploadConfig(params) {
  return client.form('/api/ops_k8s_cluster/createByUploadConfig', params);
}

// 填写配置
export function writeK8sConfig(params) {
  return client.post('/api/ops_k8s_cluster/createByToken', params);
}

// 校验
export function validateK8sCreate(params) {
  return client.post('/api/ops_k8s_cluster/createAndValidate', params);
}

// proxy地址校验
export function validateProxy(params) {
  return client.get('/api/url/verify/proxy', params);
}

// 校验制品库地址
export function validateProductLib(url) {
  return client.get('/api/url/verify/productLib', { url });
}
